import { defineNuxtPlugin } from '#app/nuxt'
import { LazySvgoFaRefresh, LazySvgoInvisible, LazySvgoLatestNews, LazySvgoRiEditBoxLine, LazySvgoRiEyeFill, LazySvgoRiHeartFill, LazySvgoRiHeartLine, LazySvgoRiStarFill, LazySvgoRiStarLine, LazySvgoRiThumbUpFill, LazySvgoRiThumbUpLine, LazySvgoAccount, LazySvgoAddcar, LazySvgoAddress, LazySvgoAfterSales, LazySvgoAsd, LazySvgoBakingSupplies, LazySvgoBaking, LazySvgoBaking2, LazySvgoBrands, LazySvgoCart, LazySvgoCartplain, LazySvgoCarts, LazySvgoCollect, LazySvgoCollect2, LazySvgoCompleted, LazySvgoContact, LazySvgoCoupons, LazySvgoCuisine, LazySvgoDailyRecipes, LazySvgoDelete, LazySvgoDelivery, LazySvgoDeliveryAddress, LazySvgoDiscount, LazySvgoDiscountinfo, LazySvgoDown, LazySvgoEdit, LazySvgoEn, LazySvgoFabu, LazySvgoFahuo, LazySvgoFans, LazySvgoFestival, LazySvgoFilter, LazySvgoFilters2, LazySvgoFt, LazySvgoFukuan, LazySvgoHint, LazySvgoHome, LazySvgoHomes, LazySvgoHot, LazySvgoHotProduct, LazySvgoHuiyuan, LazySvgoInstitutionalMembers, LazySvgoIntegrals, LazySvgoJiantou, LazySvgoJuxing, LazySvgoKitchenware, LazySvgoLatestNews2, LazySvgoLocation, LazySvgoLock, LazySvgoLoginBg, LazySvgoMastercard, LazySvgoMaterial, LazySvgoMaterial2, LazySvgoMember1, LazySvgoMembershipProgram, LazySvgoMessages, LazySvgoMoreUp, LazySvgoMore, LazySvgoNavigation, LazySvgoNew, LazySvgoNewInfo, LazySvgoOpenmore, LazySvgoPaid, LazySvgoPaysuccss, LazySvgoPhone, LazySvgoPingjia, LazySvgoPoints, LazySvgoPostsp, LazySvgoPrivacyPolicy, LazySvgoPurchased, LazySvgoQrcode, LazySvgoRecipe, LazySvgoRecipetype, LazySvgoRewardPoints, LazySvgoRight, LazySvgoSale, LazySvgoSearch, LazySvgoSeasoning, LazySvgoServe, LazySvgoSetting, LazySvgoShipping, LazySvgoShipu, LazySvgoShopcar, LazySvgoShoppingcart, LazySvgoShouhou, LazySvgoShouhuo, LazySvgoShovelSnow, LazySvgoSimplicity, LazySvgoSort, LazySvgoSorting, LazySvgoSpecial, LazySvgoSpecialOffer, LazySvgoSteps, LazySvgoStocking, LazySvgoStoreAddress, LazySvgoSuccss, LazySvgoSuccssful, LazySvgoTeach, LazySvgoTerms, LazySvgoTime, LazySvgoUp, LazySvgoUse, LazySvgoUser, LazySvgoVisa, LazySvgoVisiblePsw, LazySvgoWait, LazySvgoWaiting, LazySvgoWeighing, LazySvgoWeixin, LazySvgoZfb } from '#components'
const lazyGlobalComponents = [
  ["SvgoFaRefresh", LazySvgoFaRefresh],
["SvgoInvisible", LazySvgoInvisible],
["SvgoLatestNews", LazySvgoLatestNews],
["SvgoRiEditBoxLine", LazySvgoRiEditBoxLine],
["SvgoRiEyeFill", LazySvgoRiEyeFill],
["SvgoRiHeartFill", LazySvgoRiHeartFill],
["SvgoRiHeartLine", LazySvgoRiHeartLine],
["SvgoRiStarFill", LazySvgoRiStarFill],
["SvgoRiStarLine", LazySvgoRiStarLine],
["SvgoRiThumbUpFill", LazySvgoRiThumbUpFill],
["SvgoRiThumbUpLine", LazySvgoRiThumbUpLine],
["SvgoAccount", LazySvgoAccount],
["SvgoAddcar", LazySvgoAddcar],
["SvgoAddress", LazySvgoAddress],
["SvgoAfterSales", LazySvgoAfterSales],
["SvgoAsd", LazySvgoAsd],
["SvgoBakingSupplies", LazySvgoBakingSupplies],
["SvgoBaking", LazySvgoBaking],
["SvgoBaking2", LazySvgoBaking2],
["SvgoBrands", LazySvgoBrands],
["SvgoCart", LazySvgoCart],
["SvgoCartplain", LazySvgoCartplain],
["SvgoCarts", LazySvgoCarts],
["SvgoCollect", LazySvgoCollect],
["SvgoCollect2", LazySvgoCollect2],
["SvgoCompleted", LazySvgoCompleted],
["SvgoContact", LazySvgoContact],
["SvgoCoupons", LazySvgoCoupons],
["SvgoCuisine", LazySvgoCuisine],
["SvgoDailyRecipes", LazySvgoDailyRecipes],
["SvgoDelete", LazySvgoDelete],
["SvgoDelivery", LazySvgoDelivery],
["SvgoDeliveryAddress", LazySvgoDeliveryAddress],
["SvgoDiscount", LazySvgoDiscount],
["SvgoDiscountinfo", LazySvgoDiscountinfo],
["SvgoDown", LazySvgoDown],
["SvgoEdit", LazySvgoEdit],
["SvgoEn", LazySvgoEn],
["SvgoFabu", LazySvgoFabu],
["SvgoFahuo", LazySvgoFahuo],
["SvgoFans", LazySvgoFans],
["SvgoFestival", LazySvgoFestival],
["SvgoFilter", LazySvgoFilter],
["SvgoFilters2", LazySvgoFilters2],
["SvgoFt", LazySvgoFt],
["SvgoFukuan", LazySvgoFukuan],
["SvgoHint", LazySvgoHint],
["SvgoHome", LazySvgoHome],
["SvgoHomes", LazySvgoHomes],
["SvgoHot", LazySvgoHot],
["SvgoHotProduct", LazySvgoHotProduct],
["SvgoHuiyuan", LazySvgoHuiyuan],
["SvgoInstitutionalMembers", LazySvgoInstitutionalMembers],
["SvgoIntegrals", LazySvgoIntegrals],
["SvgoJiantou", LazySvgoJiantou],
["SvgoJuxing", LazySvgoJuxing],
["SvgoKitchenware", LazySvgoKitchenware],
["SvgoLatestNews2", LazySvgoLatestNews2],
["SvgoLocation", LazySvgoLocation],
["SvgoLock", LazySvgoLock],
["SvgoLoginBg", LazySvgoLoginBg],
["SvgoMastercard", LazySvgoMastercard],
["SvgoMaterial", LazySvgoMaterial],
["SvgoMaterial2", LazySvgoMaterial2],
["SvgoMember1", LazySvgoMember1],
["SvgoMembershipProgram", LazySvgoMembershipProgram],
["SvgoMessages", LazySvgoMessages],
["SvgoMoreUp", LazySvgoMoreUp],
["SvgoMore", LazySvgoMore],
["SvgoNavigation", LazySvgoNavigation],
["SvgoNew", LazySvgoNew],
["SvgoNewInfo", LazySvgoNewInfo],
["SvgoOpenmore", LazySvgoOpenmore],
["SvgoPaid", LazySvgoPaid],
["SvgoPaysuccss", LazySvgoPaysuccss],
["SvgoPhone", LazySvgoPhone],
["SvgoPingjia", LazySvgoPingjia],
["SvgoPoints", LazySvgoPoints],
["SvgoPostsp", LazySvgoPostsp],
["SvgoPrivacyPolicy", LazySvgoPrivacyPolicy],
["SvgoPurchased", LazySvgoPurchased],
["SvgoQrcode", LazySvgoQrcode],
["SvgoRecipe", LazySvgoRecipe],
["SvgoRecipetype", LazySvgoRecipetype],
["SvgoRewardPoints", LazySvgoRewardPoints],
["SvgoRight", LazySvgoRight],
["SvgoSale", LazySvgoSale],
["SvgoSearch", LazySvgoSearch],
["SvgoSeasoning", LazySvgoSeasoning],
["SvgoServe", LazySvgoServe],
["SvgoSetting", LazySvgoSetting],
["SvgoShipping", LazySvgoShipping],
["SvgoShipu", LazySvgoShipu],
["SvgoShopcar", LazySvgoShopcar],
["SvgoShoppingcart", LazySvgoShoppingcart],
["SvgoShouhou", LazySvgoShouhou],
["SvgoShouhuo", LazySvgoShouhuo],
["SvgoShovelSnow", LazySvgoShovelSnow],
["SvgoSimplicity", LazySvgoSimplicity],
["SvgoSort", LazySvgoSort],
["SvgoSorting", LazySvgoSorting],
["SvgoSpecial", LazySvgoSpecial],
["SvgoSpecialOffer", LazySvgoSpecialOffer],
["SvgoSteps", LazySvgoSteps],
["SvgoStocking", LazySvgoStocking],
["SvgoStoreAddress", LazySvgoStoreAddress],
["SvgoSuccss", LazySvgoSuccss],
["SvgoSuccssful", LazySvgoSuccssful],
["SvgoTeach", LazySvgoTeach],
["SvgoTerms", LazySvgoTerms],
["SvgoTime", LazySvgoTime],
["SvgoUp", LazySvgoUp],
["SvgoUse", LazySvgoUse],
["SvgoUser", LazySvgoUser],
["SvgoVisa", LazySvgoVisa],
["SvgoVisiblePsw", LazySvgoVisiblePsw],
["SvgoWait", LazySvgoWait],
["SvgoWaiting", LazySvgoWaiting],
["SvgoWeighing", LazySvgoWeighing],
["SvgoWeixin", LazySvgoWeixin],
["SvgoZfb", LazySvgoZfb],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
